module.exports = __webpack_public_path__ + "static/media/logo-dark.2d24ebf2.png";